/**
 * 活动列表
 */

import React from 'react';
import { Button, Checkbox, Col, Icon, Layout, Popover, Row, Table, Tooltip } from 'antd';
import { removeBlankValParamsStringParam } from "../utils/index";


const { Header, Sider, Content } = Layout;

class CKDataTablePage2 extends React.Component {

    constructor(props) {
        super(props);
        this.colSelectionItemPlaceholder = document.createElement("div");
        this.colSelectionItemPlaceholder.className = "col-selection-item-placeholder";
        this.state = {
            columnsControlVisible: false,
            pagination: null,
            sorter: null,
        }
    }

    tableDidMount = (table) => {
        if (!this.props.reloadOnMount && this.props.tableScrollTop) {
            const tablebody = document.querySelector('.ck-data-table .ant-table-body');
            const scrollTop = this.props.tableScrollTop[this.props.pageLocation.pathname];
            if (tablebody && scrollTop) {
                tablebody.scrollTop = scrollTop;
            }

        }
    }


    componentDidMount() {
        if (this.props.reloadOnMount || this.props.tableDataSource == null || this.props.tableDataSource.data == null)
            this.fetchTableData();

    }


    componentWillReceiveProps(nextProps) {

    }


    fetchTableData(pagination = this.state.pagination, sort) {
        this.setState({
            pagination: pagination,
            sorter: sort,
        }, () => {
            var params = this.props.tableDataSourceFetchSearchParams;
            this.props.tableDataSourceFetch(removeBlankValParamsStringParam(params), pagination, sort);
        })

    }

    handleTableChange = (pagination, filters, sorter) => {
        this.fetchTableData(pagination, sorter);
    }


    handleColumnsControlVisibleChange = (columnsControlVisible) => {
        this.setState({ columnsControlVisible });
    }


    columnsControlItemDragStart = (e) => {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        // Firefox requires calling dataTransfer .setData
        // for the drag to properly work
        e.dataTransfer.setData("text/html", e.currentTarget);
    }

    columnsControlItemDragEnd = (e) => {
        this.dragged.style.display = "block";
        if (!this.dragged.parentNode.contains(this.colSelectionItemPlaceholder)) {
            return;
        }
        this.dragged.parentNode.removeChild(this.colSelectionItemPlaceholder);

        // Upd ate state
        var columns = this.props.tableColumns;
        var from = Number(this.dragged.dataset.index);
        var to = Number(this.over.dataset.index);
        if (columns[from].fixed && !columns[to].fixed) {
            columns[from].fixed = false;
        } else if (!columns[from].fixed && columns[to].fixed) {
            columns[from].fixed = false;
            columns[to].fixed = false;
        }

        if (from < to) to--;
        columns.splice(to, 0, columns.splice(from, 1)[0]);
        this.props.tableColumnsChange(columns);
        this.dragged = null;
    }

    columnsControlItemDragOver = (e) => {
        e.preventDefault();
        this.dragged.style.display = "none";
        //确保拖拽目标
        if (e.target.className == "col-selection-item-placeholder" || e.target.className != "col-selection-item") return;
        this.over = e.target;
        e.target.parentNode.insertBefore(this.colSelectionItemPlaceholder, e.target);
    }


    render() {
        var columnsControlPopover = null;
        if (!this.props.tableColumnsControlDisable) {
            const columnsControl =
                <div className="col-selection" onDragOver={this.columnsControlItemDragOver}>
                    {Array.from(this.props.tableColumns.map((c, index) => {
                        if (c.key != 'operation') {
                            return <div className="col-selection-item" draggable="true"
                                data-index={index}
                                onDragEnd={this.columnsControlItemDragEnd}
                                onDragStart={this.columnsControlItemDragStart}
                                style={{ opacity: 1 }}
                                key={`col-selection-${c.key}-${c.dataIndex}-${index}`}>
                                <Checkbox checked={!c.hidden} onChange={(e) => {
                                    var mc = [...this.props.tableColumns];
                                    mc[index].hidden = !mc[index].hidden;
                                    this.props.tableColumnsChange(mc);
                                }}>{c.title}</Checkbox>
                                <Button size="small" shape="circle" icon="pushpin-o" onClick={(e) => {
                                    var mc = [...this.props.tableColumns];
                                    mc[index].fixed ?
                                        Array(mc.length - index).fill(index).map((e, i) => e + i).forEach((i) => {
                                            if (mc[i].key != "operation") mc[i].fixed = false;
                                        })
                                        :
                                        Array(index + 1).fill(0).map((e, i) => i).forEach((i) => {
                                            mc[i].fixed = true;
                                        });
                                    this.props.tableColumnsChange(mc);
                                }} />
                                {c.fixed && <Icon type="pushpin" />}
                            </div>
                        }
                    }
                    ))}
                </div>

            columnsControlPopover =
                <Popover content={columnsControl}
                    placement="leftTop"
                    title="列的显示|隐藏、冻结和位置(拖拽)"
                    trigger="click"
                    visible={this.state.columnsControlVisible}
                    onVisibleChange={this.handleColumnsControlVisibleChange}>
                    <Tooltip placement="top" title="显示字段设置-">
                        <Button shape="circle" icon="layout" />
                    </Tooltip>
                </Popover>
        }


        const toolbarRowSelection =
            this.props.tableSelectedRowKeys && this.props.tableSelectedRowKeys ? (
                <div className={"ck-data-table-toolbar-row-selection " + (this.props.tableSelectedRowKeys.length == 0 && "hide")}>
                    <h3>
                        已选中{this.props.tableSelectedRowKeys.length}项
                    </h3>
                    <div className="ck-data-table-toolbar-right">
                        {this.props.tableRowSelectionActions.props.children}
                    </div>
                </div>
            ) : null


        const dataSourceFetching = this.props.tableDataSource == null || this.props.tableDataSource.isFetching;


        return (

            <Layout className={this.props.className} key={"_cktp_2"}>
                <Header className={"ck-page-header"}>
                    <div className="ck-page-header-title">
                        {this.props.headerTitle.props.children}
                    </div>
                    <div className="ck-page-header-nav">
                        {this.props.headerNav.props.children}
                    </div>
                    <div className="ck-page-header-actions">
                        {this.props.headerActions.props.children}
                    </div>
                </Header>
                <Content className="page-content">
                    {this.props.pageContentPrefix}
                    <div className="ck-data-table">
                        <div className="ck-data-table-toolbar">
                            <div className="ck-data-table-toolbar-left">
                                {this.props.toolbarLeft.props.children}
                            </div>

                            <div className="ck-data-table-toolbar-right">
                                {this.props.toolbarRight}
                                {columnsControlPopover}
                            </div>
                            {toolbarRowSelection}
                        </div>
                        <div className="ck-data-table-body ck-data-table-body-fixed">

                            <Row>
                                <Col span={this.props.tableContentRow.left}>
                                    {this.props.tableContentLeft}
                                </Col>
                                <Col span={this.props.tableContentRow.right}>
                                    <Table
                                        ref={this.tableDidMount}
                                        rowClassName={this.props.rowClassName}
                                        rowKey={this.props.tableRowSelectDisabled ? null : this.props.tableRowKey}
                                        rowSelection={this.props.tableRowSelectDisabled || this.props.rowSelection ? null : {
                                            selectedRowKeys: this.props.tableSelectedRowKeys,
                                            onChange: this.props.tableSelectedRowKeysChange,
                                            onSelect: this.props.tableSelect,
                                            onSelectAll: this.props.tableSelectAll,
                                        }}
                                        loading={dataSourceFetching}
                                        columns={this.props.tableColumns.filter((e, i) => !e.hidden)}
                                        dataSource={dataSourceFetching ? [] : this.props.tableDataSource.data}
                                        expandedRowRender={this.props.expandedRowRender}
                                        locale={{
                                            emptyText: <div><Icon type="frown-o" /> 暂无数据,<a onClick={() => {
                                                this.fetchTableData(this.state.pagination, this.state.sorter)
                                            }}>立即重新加载数据?</a></div>
                                        }}
                                        pagination={
                                            this.props.pagination ?
                                                Object.assign({
                                                    showTotal: (total) => {
                                                        return <span style={{ position: "relative" }}>
                                                            <Button icon="reload" style={{ position: "absolute", right: 80 }} onClick={() => {
                                                                this.fetchTableData(this.state.pagination, this.state.sorter)
                                                            }} /> 共 {total} 条</span>
                                                    },
                                                },
                                                    this.props.tablePagination,
                                                    this.props.tableDataSource.pagination
                                                )
                                                :
                                                false
                                        }
                                        onChange={this.handleTableChange}
                                        /* body的最小宽度减去侧边栏*/
                                        scroll={{ x: this.props.tableScroll.x, y: this.props.tableScroll.y }} />
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {this.props.pageContentSuffix}
                </Content>
                {this.props.children}
            </Layout>

        )
    }
}

CKDataTablePage2.contextTypes = {};

CKDataTablePage2.defaultProps = {
    //scroll可视最小宽度
    tableScroll: { x: 701, y: 'calc(100vh - 292px)' },
    //页面导航上的左侧, 放面包屑组件
    headerTitle: <div></div>,
    //页面导航上的左侧,面包屑右侧的区域, 放一些过滤组件
    headerNav: <div></div>,
    //页面导航上的右侧, 放创建按钮
    headerActions: <div></div>,
    //TABLE工具栏左侧, 放一些过滤组件放这里
    toolbarLeft: <div></div>,
    //TABLE工具栏右侧, 放TABLE列显示控制按钮
    toolbarRight: <div></div>,
    //TABLE内容左侧放置二级菜单菜单
    tableContentLeft: <div></div>,
    //TABLE左侧菜单和table右侧的默认宽度
    tableContentRow: { left: 0, right: 24 },
    //TABLE工具栏右侧勾选了table数据后显示,显示时会遮盖table工具栏), 放批量的操作组件,比如删除
    tableRowSelectionActions: <div></div>,
    //TABLE 数据行的关键字段, 一般是id
    tableRowKey: 'key',
    tableRowSelectDisabled: false,
    //TABLE 已选择的行
    tableSelectedRowKeys: [],
    //TABLE 列的配置, 详见https://ant.design/components/table-cn/
    tableColumns: [],
    //TABLE额外展开行
    expandedRowRender: false,
    //TABLE 的数据源 过滤条件
    tableDataSourceFetchSearchParams: {},
    rowClassName: (record) => '',
    //TABLE 的数据源更新方法
    tableDataSourceFetch: (params) => null,
    tableSelectedRowKeysChange: (selectedRowKeys, selectedRecords) => null,
    tableSelect: (record, selected, selectedRows) => null,
    tableSelectAll: (selected, selectedRows, changeRows) => null,
    tableColumnsChange: (columns) => null,
    //TABLE 的数据的分页信息
    pagination: true,
    tablePagination: {
        pageSizeOptions: ['20', '50', '100'],
        defaultPageSize: 20,
        showSizeChanger: true,

    },
    tableSorter: {},
    tableFilters: {},
    //列显示控制是否禁用
    tableColumnsControlDisable: false,
    rowSelection: false,
    reloadOnMount: false,
    menuSider: null,
};

CKDataTablePage2.propTypes = {}

export default CKDataTablePage2;




// WEBPACK FOOTER //
// ./src/components/CKDataTablePage2.jsx